var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10387 8.13623L9.07354 14.8947C9.36644 15.1787 9.36644 15.6392 9.07354 15.9232C8.78065 16.2072 8.30578 16.2072 8.01288 15.9232L0.512883 8.65049C0.21999 8.36647 0.21999 7.90599 0.512883 7.62197L8.01288 0.349244C8.30578 0.0652261 8.78065 0.065226 9.07354 0.349244C9.36644 0.633261 9.36644 1.09375 9.07354 1.37776L2.10387 8.13623Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back-arrow.80a87ff539b350e04fb94a9e40dbd1e0.svg";